import React, {useContext} from "react";
import {makeStyles} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import FilterPanel from './FilterPanel';
import FilterContext from "../FilterContext";
import {Container, FormControlLabel, FormHelperText, FormLabel, RadioGroup} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
        textAlign: 'left',
        padding: '0.5rem 1rem'
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
    },
    margin: {
        marginLeft: 'auto'
    }
}));

const LocationFilters = (props) => {
    const classes = useStyles();
    const [context, setContext] = useContext(FilterContext);

    const handleChange = (event) => {
        const value = event.target.value;
        delete context.filters.region;

        if (value > 0) {
            setContext({
                ...context,
                filters: {
                    ...context.filters,
                    shapeId: Number(value)
                }
            });
        } else {
            delete context.filters.shapeId;
            setContext({...context, filters: {...context.filters}});
        }
    }

    const shapeId = context.filters.shapeId;

    return (
        <FilterPanel sidebarWidth={props.sidebarWidth} selected={props.selected} close={props.close}>
            <Container>
                <h3>Location</h3>
                <FormControl className={classes.formControl}>
                    <RadioGroup
                        onChange={handleChange}
                        value={shapeId ? shapeId : -1}>
                        <FormControlLabel key={9999} value={-1} control={<Radio/>} label="None"/>

                        {context.shapes.shapes.map(it => (
                            <FormControlLabel key={it.id} value={it.id} control={<Radio/>} label={it.name}/>)
                        )}
                    </RadioGroup>
                </FormControl>
            </Container>
        </FilterPanel>
    );
}

export default LocationFilters;
